<div class="flex-fill-column flex-column-ns">
  <form class="flex-column-ns cng-dark-contrast" (submit)="search()" [formGroup]="formlyForm">
    <div class="flex-row-ns searchContainer">
      <mat-form-field>
        <mat-label>{{ 'commons:basic.search' | translate }}</mat-label>
        <input matInput type="text" name="searchValue" [formControlName]="Filter.SEARCH_VALUE" />
      </mat-form-field>
      <div class="actionButtons">
        <button mat-icon-button type="submit" [matTooltip]="'commons:actions.search' | translate">
          <mat-icon>search</mat-icon>
          <span class="nodisplay">{{ 'commons:actions.search' | translate }}</span>
        </button>
        <button mat-icon-button type="button" (click)="resetSearch()" [matTooltip]="'commons:actions.erase' | translate">
          <mat-icon>erase</mat-icon>
          <span class="nodisplay">{{ 'commons:actions.erase' | translate }}</span>
        </button>
      </div>
    </div>
  </form>
  <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="tabChanged($event)" class="flex-fill-column">
    <mat-tab *ngIf="!!mediaExternalId">
      <ng-template mat-tab-label>
        <ng-container>
          {{ 'agent:panel.knowledge_base.suggested' | translate }}
        </ng-container>
        <span counter>{{ suggestedResults.length }}</span>
      </ng-template>
      <knowledge-base-suggestions [mediaExternalId]="mediaExternalId"></knowledge-base-suggestions>
    </mat-tab>
    <mat-tab label="{{ 'agent:panel.knowledge_base.tree' | translate }}">
      <knowledge-base-tree [canCopyPaste]="!!mediaExternalId || outgoingMailOpened"></knowledge-base-tree>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <ng-container>
          {{ 'agent:panel.knowledge_base.results' | translate }}
        </ng-container>
        <span counter>{{ searchResults.length }}</span>
      </ng-template>
      <knowledge-base-search [searchValue]="searchText" [canCopyPaste]="!!mediaExternalId || outgoingMailOpened"></knowledge-base-search>
    </mat-tab>
  </mat-tab-group>
</div>
